import { FC, useState } from "react";
import { Row, Segmented, Space } from "antd";
import ReactECharts from "echarts-for-react";
import { Period } from "../../../../types/SupplierTypes";
import { getChartOption } from "./CostAndMarginsChartOption";
import styles from "./CostAndMarginsChart.module.less";
import { IncomeStatement, PeriodData } from "../../../../types/FinanceTypes";

const periodOptions = Object.keys(Period);

export interface CostAndMarginsChartProps {
    incomes?: PeriodData<IncomeStatement>;
}

export const CostAndMarginsChart: FC<CostAndMarginsChartProps> = ({ incomes }) => {
    const [period, setPeriod] = useState(Period.Quarterly);

    if (!incomes) return null;

    const periodData = period === Period.Annually ? incomes.annually : incomes.quarterly;
    const _incomes = periodData.slice(0, 8).reverse();
    const option = getChartOption({ incomes: _incomes, period });

    return (
        <>
            <Row justify="end">
                <Space size={32}>
                    <Space size={12}>
                        <span className={styles.legendGreen}>Sold</span>
                        <span className={styles.legendOrange}>Margins</span>
                        <span className={styles.legendRed}>Cost</span>
                    </Space>
                    <Segmented
                        size="small"
                        options={periodOptions}
                        value={period}
                        onChange={(value) => setPeriod(value as Period)}
                    />
                </Space>
            </Row>
            <ReactECharts
                style={{
                    width: "100%",
                    height: 122,
                }}
                option={option}
            />
        </>
    );
};
